import { LeftOutlined } from "@ant-design/icons";
import "./MobileHeaderDropdown.scss";
import { isProSubscription } from "../../service/BillingService";
import { useRecoilState } from "recoil";
import { memberState } from "../../state/atoms";

export interface MobileTemplatesDropdownProps {
  toggleTemplates: (ev: React.MouseEvent) => void;
}

export default function MobileTemplatesDropdown({ toggleTemplates } : MobileTemplatesDropdownProps) {
  const [member] = useRecoilState(memberState);

  if (member.holidayTemplates) {
    return (
      <ul className={"drawer-nav"}>
        <li className="header" onClick={(ev) => toggleTemplates(ev)}>
          <LeftOutlined/>
          <span>Templates</span>
        </li>
        <li>
          <a href="/category/holiday-menus.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/Templates.svg" alt="menu templates"/>
            <span>Holiday Menu Templates</span>
          </a>
        </li>
        <li>
          <a href="/category/holiday-flyers.html">
            <img src="https://timber.mhmcdn.com/site/marketing/icons/FilterProducts/Flyer.svg" alt="flyer templates"/>
            <span>Holiday Flyer Templates</span>
          </a>
        </li>
      </ul>
    );
  }

  return (
    <ul className={"drawer-nav"}>
      <li className="header" onClick={(ev) => toggleTemplates(ev)}>
        <LeftOutlined/>
        <span>Templates</span>
      </li>
      <li>
        <a href="/menu/browse.do">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/Templates.svg" alt="menu templates"/>
          <span>Menu Templates</span>
        </a>
      </li>
      <li className={member.id && !isProSubscription(member) ? 'gray-out' : ''}>
        <a href="/category/Digital-Menu-Boards.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/DigiBoard.svg" alt="digital signage"/>
          <span>Digital Signage</span>
        </a>
        {member.id && !isProSubscription(member) && 
        <img className="pro-star" src="https://timber.mhmcdn.com/site/marketing/icons/ProPricingStar.svg" alt="pro star"/>}
      </li>
      <li>
        <a href="/category/takeout-menus.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/FilterProducts/Takeout.svg" alt="takeout templates"/>
          <span>Takeout Templates</span>
        </a>
      </li>
      <li>
        <a href="/category/half-page-menus.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/FilterProducts/HalfPageMenu.svg" alt="half page templates"/>
          <span>Half Page Templates</span>
        </a>
      </li>
      <li>
        <a href="/category/restaurant-flyer.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/FilterProducts/Flyer.svg" alt="flyer templates"/>
          <span>Flyer Templates</span>
        </a>
      </li>
      <li>
        <a href="/category/business-cards.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/FilterProducts/BusinessCard.svg" alt="business card templates"/>
          <span>Business Card Templates</span>
        </a>
      </li>
      <li>
        <a href="/category/table-tent.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/FilterProducts/TableTent.svg" alt="table tent templates"/>
          <span>Table Tent Templates</span>
        </a>
      </li>
      <li>
        <a href="/category/marketing-templates.html">
          <span>...and more</span>
        </a>
      </li>
    </ul>
  )
}